export default class TextoValor {
  public valor: number;
  public texto: string;

  constructor(valor: number, texto: string) {
    this.valor = valor;
    this.texto = texto;
  }
}
